/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { SiegeSocialGridDto } from './SiegeSocialGridDto';
import {
    SiegeSocialGridDtoFromJSON,
    SiegeSocialGridDtoFromJSONTyped,
    SiegeSocialGridDtoToJSON,
} from './SiegeSocialGridDto';

/**
 * 
 * @export
 * @interface SiegeSocialGridDtoPaginatedResults
 */
export interface SiegeSocialGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SiegeSocialGridDto>}
     * @memberof SiegeSocialGridDtoPaginatedResults
     */
    results?: Array<SiegeSocialGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof SiegeSocialGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the SiegeSocialGridDtoPaginatedResults interface.
 */
export function instanceOfSiegeSocialGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeSocialGridDtoPaginatedResultsFromJSON(json: any): SiegeSocialGridDtoPaginatedResults {
    return SiegeSocialGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function SiegeSocialGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeSocialGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(SiegeSocialGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function SiegeSocialGridDtoPaginatedResultsToJSON(value?: SiegeSocialGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(SiegeSocialGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

